import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { classToFComponent, FCClassContext } from 'src/utils/views'

import ChartTotalEmpresasView from '../../the-consumer-market/views/tcm_chart_total_empresas'
import { WebPageScope } from '../mv_scopes'
import { CategoriaTableView, FotoCardView, LoadError, WordCloudView } from './mv_components'
import { PointsMapView } from './mv_points_map'
import { EstabelecimentosTableView } from './mv_tables'

const useStyles = makeStyles()({
    page: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        minWidth: 0
    },
    topGrid: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1.1fr) minmax(0, 1fr) minmax(0, 1.2fr)',
        gridTemplateRows: '88px 370px',
        gridTemplateAreas: `
            "kpis nuvem mapa"
            "categorias nuvem mapa"
        `,
        gap: 10,
        '@media (max-width: 1240px)': {
            gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
            gridTemplateRows: '88px 370px 420px',
            gridTemplateAreas: `
                "kpis nuvem"
                "categorias nuvem"
                "mapa mapa"
            `
        },
        '@media (max-width: 720px)': {
            gridTemplateColumns: 'minmax(0, 1fr)',
            gridTemplateRows: '88px 320px 320px 380px',
            gridTemplateAreas: '"kpis" "categorias" "nuvem" "mapa"'
        }
    },
    bottomGrid: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 2.1fr) minmax(0, 1.2fr)',
        gridTemplateRows: '560px',
        gridTemplateAreas: '"detalhe foto"',
        gap: 10,
        '@media (max-width: 1240px)': {
            gridTemplateColumns: 'minmax(0, 1fr)',
            gridTemplateRows: '540px 520px',
            gridTemplateAreas: '"detalhe" "foto"'
        }
    },
    kpis: {
        gridArea: 'kpis',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: 8
    },
    nuvem: { gridArea: 'nuvem' },
    categorias: { gridArea: 'categorias' },
    mapa: { gridArea: 'mapa' },
    detalhe: { gridArea: 'detalhe' },
    foto: { gridArea: 'foto' }
})

type WebPageViewProps = {
    className?: string
    scope: WebPageScope
}

class WebPageViewClass implements FCClassContext<WebPageViewProps> {
    scope!: WebPageScope
    classes!: ReturnType<typeof useStyles>['classes']

    onSyncState({ scope }: WebPageViewProps) {
        this.scope = scope
        this.classes = useStyles().classes
    }

    render({ className }: WebPageViewProps) {
        const { classes, scope } = this
        return (
            <div className={className}>
                <div className={classes.page}>
                    <LoadError message={scope.erro} />

                    <div className={classes.topGrid}>
                        <div className={classes.kpis}>
                            <ChartTotalEmpresasView scope={scope.totalEstabelecimentos} />
                            <ChartTotalEmpresasView scope={scope.totalAbertas24h} />
                            <ChartTotalEmpresasView scope={scope.totalFotos} />
                        </div>
                        <WordCloudView className={classes.nuvem} scope={scope.nuvem} />
                        <CategoriaTableView className={classes.categorias} scope={scope.categorias} />
                        <PointsMapView className={classes.mapa} scope={scope.mapa} />
                    </div>

                    <div className={classes.bottomGrid}>
                        <EstabelecimentosTableView className={classes.detalhe} scope={scope.detalhamento} />
                        <FotoCardView className={classes.foto} scope={scope.foto} />
                    </div>
                </div>
            </div>
        )
    }
}

export const WebPageView = classToFComponent(WebPageViewClass, React)
